(function () {
  function setButtonState(button, state, label) {
    var labelEl = button.querySelector('[data-pdp-reset-coupon-copy-label]');
    if (labelEl) {
      labelEl.textContent = label;
    }

    button.classList.toggle('is-copied', state === 'copied');
    button.classList.toggle('is-error', state === 'error');
  }

  function fallbackCopy(text) {
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        var successful = document.execCommand('copy');
        document.body.removeChild(textarea);
        successful ? resolve() : reject(new Error('Fallback copy failed'));
      } catch (error) {
        document.body.removeChild(textarea);
        reject(error);
      }
    });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () {
        return fallbackCopy(text);
      });
    }

    return fallbackCopy(text);
  }

  function restoreButton(instance, button, code) {
    window.clearTimeout(instance.pdpResetCouponTimer);
    setButtonState(button, 'idle', 'Copy');
    button.setAttribute('aria-label', 'Copy coupon code ' + code);
  }

  function initCoupon(instance) {
    if (instance.dataset.pdpResetCouponReady === 'true') {
      return;
    }

    var button = instance.querySelector('[data-pdp-reset-coupon-copy]');
    var code = (instance.dataset.couponCode || '').trim();
    var resetMs = parseInt(instance.dataset.resetMs, 10);

    if (!button || !code) {
      return;
    }

    if (!resetMs || resetMs < 0) {
      resetMs = 5000;
    }

    instance.dataset.pdpResetCouponReady = 'true';

    button.addEventListener('click', function () {
      window.clearTimeout(instance.pdpResetCouponTimer);

      copyText(code)
        .then(function () {
          setButtonState(button, 'copied', 'Copied!');
          button.setAttribute('aria-label', 'Coupon code ' + code + ' copied');
          instance.pdpResetCouponTimer = window.setTimeout(function () {
            restoreButton(instance, button, code);
          }, resetMs);
        })
        .catch(function () {
          setButtonState(button, 'error', 'Try again');
          button.setAttribute('aria-label', 'Copy coupon code ' + code + ' failed, try again');
          instance.pdpResetCouponTimer = window.setTimeout(function () {
            restoreButton(instance, button, code);
          }, resetMs);
        });
    });
  }

  function initAllCoupons() {
    document.querySelectorAll('[data-pdp-reset-coupon]').forEach(initCoupon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCoupons);
  } else {
    initAllCoupons();
  }

  document.addEventListener('shopify:section:load', initAllCoupons);
})();
